// extracted by mini-css-extract-plugin
export default {"subDescription":"FieldSubDescription_subDescription__cKO5N"};